import React from 'react';
import {
    OperationWithLocation,
    formatNominatedWeightDisplay,
    formatBillOfLadingWeightDisplay,
    formatShipFigureDisplay,
    formatStowedWeightDisplay,
    formatNotStowedWeightDisplay,
    getWarningClass,
    RotationCargoOperationVM,
} from 'src/utils/stowage/stowageOperation/operationFormatUtils';
import { OperationsTableRow, OperationsTableCell } from './OperationsForCargoPanel.styles';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { Stowage } from 'src/types/ViewModel/Stowage/Stowage';
import PortBerthCell from './PortBerthCell';
import StowageItemsRow from './StowageItemsRow';
import { getShipFigureCssClass } from 'src/utils/stowage/stowageOperation/operationDisplayUtil';

interface OperationRowProps {
    item: OperationWithLocation;
    prevOperation: RotationCargoOperationVM | null;
    showStowageItems: boolean;
    activeStowagePlan: StowagePlan | null;
    stowageItems: Stowage[];
    onPortClick: (portCallGuid: string) => void;
    onBerthClick: (portCallGuid: string, berthCallGuid: string) => void;
}

const OperationRow: React.FC<OperationRowProps> = ({
    item,
    prevOperation,
    showStowageItems,
    activeStowagePlan,
    stowageItems,
    onPortClick,
    onBerthClick,
}) => {
    const operation = item.operation;
    const shipFigureCssClass =
        activeStowagePlan && operation.orgCargoOperation ? getShipFigureCssClass(activeStowagePlan, operation.orgCargoOperation) : '';

    return (
        <>
            <OperationsTableRow>
                <OperationsTableCell>{operation.cargoOperationOrderNumber || '—'}</OperationsTableCell>
                <PortBerthCell item={item} prevOperation={prevOperation} onPortClick={onPortClick} onBerthClick={onBerthClick} />
                <OperationsTableCell>{formatNominatedWeightDisplay(operation)}</OperationsTableCell>
                <OperationsTableCell>{formatBillOfLadingWeightDisplay(operation)}</OperationsTableCell>
                <OperationsTableCell className={shipFigureCssClass}>{formatShipFigureDisplay(operation, activeStowagePlan)}</OperationsTableCell>
                <OperationsTableCell>{formatStowedWeightDisplay(item)}</OperationsTableCell>
                <OperationsTableCell className={getWarningClass(activeStowagePlan, operation.orgCargoOperation)}>
                    {formatNotStowedWeightDisplay(item)}
                </OperationsTableCell>
            </OperationsTableRow>

            {showStowageItems && <StowageItemsRow item={item} columnCount={7} stowageItems={stowageItems} />}
        </>
    );
};

export default OperationRow;
